module.exports = __webpack_public_path__ + "img/whats-new-1_en.a7964b0.jpg";